import { render, staticRenderFns } from "./orderView.vue?vue&type=template&id=0e90df99&scoped=true"
import script from "./orderView.vue?vue&type=script&lang=js"
export * from "./orderView.vue?vue&type=script&lang=js"
import style0 from "./orderView.vue?vue&type=style&index=0&id=0e90df99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e90df99",
  null
  
)

export default component.exports